module.exports = __webpack_public_path__ + "static/media/ResumeLarsen.7c768bd0.png";